import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router";
import { setIsHomeProcess } from "../../app/GlobalSlice";
import { formatRupiah } from "../../utils/NumericHelper"

import { logout } from "../../app/Api"
import { handleAxiosNetworkError, handleResponse200 } from "../../utils/HttpUtils";
import { notifyError, notifySuccess } from "../../utils/Notification";
import { isPhone } from "../../utils/PlatformHelper";

import { format } from "date-fns"

const phaseToLabel = (phase) => {
  if (phase === "on_payment") {
    return 'Pembayaran'
  }
  else if (phase === "on_biodata") {
    return 'Pelengkapan Biodata'
  }
  else if (phase === "on_schedule_test") {
    return 'Atur Jadwal Ujian'
  }
  else if (phase === "on_document") {
    return 'Pelengkapan Dokumen'
  }
  else if (phase === "on_finish") {
    return 'Selesai'
  }
}

const phaseToLink = (phase) => {
  if (phase === "on_payment") {
    return '/home/payment'
  }
  else if (phase === "on_biodata") {
    return '/home/biodata'
  }
  else if (phase === "on_schedule_test") {
    return '/home/schedule-test'
  }
  else if (phase === "on_document") {
    return '/home/document'
  }
  else if (phase === "on_finish") {
    return 'Selesai'
  }
}

const phaseToButtonLabel = (phase) => {
  if (phase === "on_payment") {
    return 'Lanjut Pembayaran'
  }
  else if (phase === "on_biodata") {
    return 'Lengkapi Biodata'
  }
  else if (phase === "on_schedule_test") {
    return 'Atur Jadwal Ujian'
  }
  else if (phase === "on_document") {
    return 'Lengkapi Dokumen'
  }
  else if (phase === "on_finish") {
    return 'Selesai'
  }
}

const WelcomePage = () => {
  const dispatch = useDispatch()
  const navigate = useNavigate()

  const {
    member,
    systemProfile,
    screenSize
  } = useSelector(state => state.global)

  useEffect(() => {
    document.body.style.backgroundColor = isPhone(screenSize.width) ? 'white' : '#232745';
  }, [screenSize.width])

  if (!systemProfile) return null;

  if (member === null) {
    return (
      <div
        className="w-screen h-screen"
        style={{
          backgroundColor: '#232745'
        }}
      >

        <div
          className="py-10 flex justify-center"
        >
          
          <div
            className="relative rounded-sm flex"
            style={{
              width: '650px',
              height: '700px'
            }}
          >
            
            <div
              className="flex-1 bg-white p-10"
            >
            </div>

          </div>
          

        </div>
      </div>
    )
  }

  function onLogout() {
    dispatch(setIsHomeProcess(true))

    logout()
      .then(res => {
        handleResponse200({
          httpResponse: res,
          onSuccess: payload => {
            notifySuccess('Logout Berhasil')
            navigate("/login")
          },
          onRecovFailure: errors => errors.forEach(err => {
              notifyError(err)
          }),
          onUnAuth: error => {
              
          },
          onTechnicalError: errors => errors.forEach(err => {
            notifyError(err)
          })
        })
      })
      .catch(handleAxiosNetworkError)
      .finally(() => { dispatch(setIsHomeProcess(false)) })
  }

  return (
    <div
      className="h-screen"
    >
      <div
        className="py-10 flex justify-center"
      >

        <div
          className="relative rounded-sm flex"
          style={{
            width: '600px'
          }}
        >
          <div
            className="w-full bg-white rounded-lg"
          >
            <div
              className="flex justify-center pt-8"
            >
              <img src={systemProfile.companyLogo + '?' + Date.now()} width={'150px'}/>
            </div>
            <div
              className="py-5 flex justify-center"
            >
              <div
                className="w-2/3 text-center"
              >
                <p>Selamat datang kembali di {systemProfile.companyPmb}.</p>
                <p>Anda telah login dengan detail akun sebagai berikut</p>
              </div>
            </div>
            <div
              className="py-3 border-t border-b flex justify-center"
            >
              <div
                className="space-y-2 py-3"
                style={{
                  fontSize: '14px',
                  width: '60%'
                }}
              >
                <div
                  className={
                    "flex "+
                    (isPhone(screenSize.width) ? ' flex-col text-left py-1 ' : ' flex-col ')
                  }
                >
                  <div className="w-28">ID Peserta</div>
                  {/* {!isPhone(screenSize.width) && (<div>:</div>)} */}
                  <div className="font-bold">{member.idParticipant}</div>
                </div>
                <div
                  className={
                    "flex "+
                    (isPhone(screenSize.width) ? ' flex-col text-left py-1 ' : ' flex-col ')
                  }
                >
                  <div className="w-28">Nama Lengkap</div>
                  {/* {!isPhone(screenSize.width) && (<div>:</div>)} */}
                  <div className="font-bold">{member.namaParticipant}</div>
                </div>
                <div
                  className={
                    "flex "+
                    (isPhone(screenSize.width) ? ' flex-col text-left py-1 ' : ' flex-col ')
                  }
                >
                  <div className="w-28">No. HP</div>
                  {/* {!isPhone(screenSize.width) && (<div>:</div>)} */}
                  <div className="font-bold">+62 - {member.noHp}</div>
                </div>
                <div
                  className={
                    "flex "+
                    (isPhone(screenSize.width) ? ' flex-col text-left py-1 ' : ' flex-col ')
                  }
                >
                  <div className="w-28">Tgl. Daftar</div>
                  {/* {!isPhone(screenSize.width) && (<div>:</div>)} */}
                  <div className="font-bold">{format(new Date(member.registeredAt), "dd/MM/yyyy")}</div>
                </div>
                <div
                  className={
                    "flex "+
                    (isPhone(screenSize.width) ? ' flex-col text-left py-1 ' : ' flex-col ')
                  }
                >
                  <div className="w-28">Program</div>
                  {/* {!isPhone(screenSize.width) && (<div>:</div>)} */}
                  <div className="font-bold">{member.program.label}</div>
                </div>
                <div
                  className={
                    "flex "+
                    (isPhone(screenSize.width) ? ' flex-col text-left py-1 ' : ' flex-col ')
                  }
                >
                  <div className="w-28">Sekolah</div>
                  {/* {!isPhone(screenSize.width) && (<div>:</div>)} */}
                  <div className="font-bold">{member.sekolah.label}</div>
                </div>
                <div
                  className={
                    "flex "+
                    (isPhone(screenSize.width) ? ' flex-col text-left py-1 ' : ' flex-col ')
                  }
                >
                  <div className="w-28">Biaya Daftar</div>
                  {/* {!isPhone(screenSize.width) && (<div>:</div>)} */}
                  <div className="font-bold">{formatRupiah(member.biayaPendaftaran)}</div>
                </div>
                <div
                  className={
                    "flex "+
                    (isPhone(screenSize.width) ? ' flex-col text-left py-1 ' : ' flex-col ')
                  }
                >
                  <div className="w-28">Uang Pangkal</div>
                  <div className="font-bold">
                    {
                      member.jenisHargaUangPangkal === 'harga_eksak' ?
                        (<label>
                          <span className={member.uangPangkalPromo ? 'line-through' : ''}>{formatRupiah(member.uangPangkal)}</span> {member.uangPangkalPromo && (<span>{formatRupiah(member.uangPangkalPromo)}</span>)}
                          </label>) 
                        :
                        (<label>{formatRupiah(member.uangPangkalRentangDari)} - {formatRupiah(member.uangPangkalRentangHingga)} </label>)
                    }
                  </div>
                </div>
                <div
                  className={
                    "flex "+
                    (isPhone(screenSize.width) ? ' flex-col text-left py-1 ' : ' flex-col ')
                  }
                >
                  <div className="w-28">Fase Saat Ini</div>
                  {/* {!isPhone(screenSize.width) && (<div>:</div>)} */}
                  <div className="font-bold">
                    {member.currentPhase == "on_payment" ?
                      <p>Menunggu Pembayaran</p>
                      :
                      member.currentPhase != "on_payment" && member.isLulus == null ?
                        <p>Menunggu hasil status ujian</p>
                        :
                        member.isLulus ?
                          phaseToLabel(member.currentPhase)
                          :
                          <p>Maaf, ananda dinyatakan tidak lulus</p>
                    }
                  </div>
                </div>
              </div>
            </div>
            <div
              className="py-5 pb-8 flex justify-center"
            >
              <div
                className="w-2/3 px-10 space-y-5"
              >
                {((member.currentPhase == "on_payment" || member.isLulus) && member.currentPhase !== 'on_finish') && (
                  <button
                    className="w-full bg-blue-500 text-white py-1.5 rounded-md"
                    style={{
                      fontSize: '14px'
                    }}
                    onClick={() => navigate(phaseToLink(member.currentPhase))}
                  >
                    {phaseToButtonLabel(member.currentPhase)}
                  </button>
                )}
                <button
                  className="w-full border border-blue-500 py-1.5 rounded-md hover:bg-blue-500 hover:text-white"
                  style={{
                    fontSize: '14px'
                  }}
                  onClick={onLogout}
                >
                  Keluar
                </button>
              </div>
            </div>


          </div>
        </div>


      </div>

    </div>
  )

}

export default WelcomePage;